export const environment = {
  //root:'https://bicialtagama.codingco.io',
  root:'https://bicicletasbanco.supervielleseguros.com.ar/cotiz2/seguro-bicicleta-banco/',
  production: true,
  api123: 'https://cotizar-service.123seguro.com/api/v1/AR/',
  api123v2: 'https://cotizar-service.123seguro.com/api/v2/AR/',
  //apiSV: 'https://bicialtagama.codingco.io/api/public/',
  apiSV: 'https://bicicletasbanco.supervielleseguros.com.ar/cotiz2/seguro-bicicleta-banco/api/public/',
  oauth123: 'https://bicicletasbanco.supervielleseguros.com.ar/cotiz2/seguro-bicicleta-banco/oauth.php'
};